/* eslint-disable */
(async () => {
  const insightsForm = document.getElementById('insights-form');
  const insightsContainer = document.getElementById('insights-container');
  const insightTemplate = document.getElementById('insight-card-template');
  const insightsSearchInput = document.getElementById('insights-search-input');
  const insightsSubmitButton = document.getElementById('insights-search-submit');
  const insightsLoadingContainer = document.getElementById('insights__loading-container');
  const insightsPaginationButton = document.getElementById('insights-form-pagination-button');
  const categoriesMenu = document.getElementById('categories-menu');
  const categoriesMenuButton = document.getElementById('categories-menu-button');
  const categoriesMenuSelected = document.getElementById('categories-menu-selected');
  const categoryItemTemplate = document.getElementById('category-item-template');

  const state = {
    page: 1,
    searchTerm: null,
    selectedInsightCategories: new Set(),
    moreInsights: true,
  };

  const categories = await getArticleCategories();

  // const tl = gsap.timeline({ paused: true });
  const loadingTl = gsap.timeline({
    paused: true,
  })
    .fromTo(insightsLoadingContainer, {
      opacity: '0',
    }, {
      opacity: '1',
      duration: 0.15,
    });

  const categoriesMenuTl = gsap.timeline({
    paused: true,
  })
    .fromTo(categoriesMenu, {
      display: 'none',
    }, {
      display: 'flex',
      duration: 0.01,
    })
    .fromTo(categoriesMenu, {
      height: '0',
      boxShadow: 'none',
    }, {
      height: 'auto',
      boxShadow: '7px 7px 6px rgba(0, 0, 0, 0.39)',
      duration: 0.5,
    });

  async function init() {
    readURL();
    populateMenu();
    addListeners();    
    const insights = await getInsights(state.page);
    state.moreInsights = insights.remaining;
    appendInsights(insights.posts);
    insightsPaginationButton.style.display = state.moreInsights ? 'block' : 'none';
    initialLoadStackTrigger();
  }
  await init();

  async function populateMenu() {
    populateCategories();
  }

  function addListeners() {
    categoriesMenuButton.addEventListener('click', toggleCategoriesMenu);
    insightsForm.addEventListener('change', handleFormChange);
    insightsForm.addEventListener('submit', handleFormSubmit);
    insightsSearchInput.addEventListener('keydown', handleFormChange);
    insightsSubmitButton.addEventListener('click', handleFormChange);
    insightsPaginationButton.addEventListener('click', handlePagination);

    window.addEventListener('popstate', handleBackButton);
  }

  function handleCategoryItemSeparator() {
    const elements = document.querySelectorAll('.category-item');
    for (let i = 0; i < elements.length - 1; i++) {
      const currentElement = elements[i];
      const nextElement = elements[i + 1];
  
      if (currentElement.classList.contains('selected') && nextElement.classList.contains('selected')) {
        currentElement.classList.add('show-separator');
      } else {
        currentElement.classList.remove('show-separator');
      }
    }
  }

  function handleCategoryValue(categoryItem) {
    const selected = categoryItem.classList.contains('selected');
    const checkbox = categoryItem.querySelector('input');
    const firstCategorySelected = document.querySelector(`input[data-name-id="${Array.from(state.selectedInsightCategories)[0]}"]`);

    if (state.selectedInsightCategories.size > 1) {
      categoriesMenuSelected.value = 'Multiple Categories Selected';
    } else if (state.selectedInsightCategories.size === 1) {
      categoriesMenuSelected.value = firstCategorySelected.id;
    } else {
      categoriesMenuSelected.value = '';
    }
  }

  async function handleFormChange(event) {
    const target = event.target;

    if (target.type === 'checkbox') {
      const categoryItem = target.parentElement;
      if (target.checked) {
        state.selectedInsightCategories.add(+target.dataset.nameId);
        categoryItem.classList.add('selected');
      } else {
        state.selectedInsightCategories.delete(+target.dataset.nameId);
        categoryItem.classList.remove('selected');
      }
      handleCategoryItemSeparator();
      handleCategoryValue(categoryItem);
    } else if (target.type === 'text') {
      state.searchTerm = insightsSearchInput.value;
      if (event.type === 'keydown' && event.keyCode === 13) {
        insightsSubmitButton.click();
        toggleCategoriesMenu(event);
      } else {
        return;
      }
    } else if (target.type === 'button') {
      state.searchTerm = insightsSearchInput.value;
      if (insightsSearchInput.value === '') return;
    }

    state.page = 1;
    const insights = await getInsights();
    insightsContainer.innerHTML = '';
    appendInsights(insights.posts);

    state.moreInsights = insights.remaining;
    insightsPaginationButton.style.display = state.moreInsights ? 'block' : 'none';
    updateURL();
    focusFirstNewInsight(insights);
  }

  function handleFormSubmit(event) {
    event.preventDefault();
  }

  function handleBackButton() {
    window.location.reload();
  }

  function populateCategories() {
    if (!categories) return;

    categories.forEach(category => {      
      if (category.count > 0) {
        const categoryItemClone = createCategoryItem(category.name, category.term_id);
        categoriesMenu.appendChild(categoryItemClone);
      }
    });
  }

  function toggleCategoriesMenu(event) {
    const menuOpen = categoriesMenuButton.getAttribute('aria-pressed') === 'true';
    const body = document.getElementsByTagName('body')[0];
    
    categoriesMenuButton.setAttribute('aria-pressed', !menuOpen);
    categoriesMenuButton.setAttribute('aria-expanded', !menuOpen);

    function bodyClick(event){
      const target = event.target;
      const isCategoriesAncestor = target.closest('.categories');

      if (!isCategoriesAncestor) {
        categoriesMenuTl.reverse();
        body.removeEventListener('click', bodyClick, false);
        categoriesMenuButton.setAttribute('aria-pressed', false);
        categoriesMenuButton.setAttribute('aria-expanded', false);
      }
    }

    if (menuOpen) {
      categoriesMenuTl.reverse();
      body.removeEventListener('click', bodyClick, false);
    } else {
      categoriesMenuTl.play();
      body.addEventListener('click', bodyClick);
    }
  }

  function categoryItemSelect(event) {
    const categoryItem = event.target;
    const menuOpen = categoriesMenuButton.getAttribute('aria-pressed') === 'true';
    if (!menuOpen || categoryItem.tagName !== 'INPUT') return;
  }

  function createCategoryItem(name, id) {
    const categoryItemClone = categoryItemTemplate.content.cloneNode(true);

    const checkbox = categoryItemClone.querySelector('.category-item__checkbox');
    const label = categoryItemClone.querySelector('.category-item__label');
    const text = categoryItemClone.querySelector('.category-item__text');

    checkbox.setAttribute('id', name);
    checkbox.setAttribute('data-name-id', id);
    checkbox.setAttribute('name', name);
    label.setAttribute('for', name);
    text.innerHTML = name;

    return categoryItemClone;
  }

  async function getArticleCategories() {
    try {
      const data = new FormData();

      data.append('action', 'get_category_filter_data');
      data.append('nonce', insightsAjax.posts_query_nonce);

      const response = await fetch(insightsAjax.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: data,
      });

      if (response.ok === false) {
        throw new Error('get insight categories failed');
      }

      const allCategories = await response.json();

      return allCategories;
    } catch (error) {
      return null;
    }
  }

  async function getInsights(pages) {
    try {
      setLoading(true);
      const offset = pages ? 0 : (state.page - 1) * 6;
      const defaultedPages = pages || 1;
      const data = new FormData();
      data.append('action', 'get_filtered_articles');
      data.append('nonce', insightsAjax.posts_query_nonce);
      data.append('searchTerm', state.searchTerm || '');
      data.append('categories', JSON.stringify(Array.from(state.selectedInsightCategories)));
      data.append('offset', offset);
      data.append('numberPosts', 6 * defaultedPages);
      const response = await fetch(insightsAjax.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: data,
      });

      if (response.ok === false) {
        throw new Error('filter insights failed');
      }

      const insights = await response.json();

      setTimeout(setLoadingFalse, 150);

      return insights;
    } catch (e) {
      // console.log(e);
      return null;
    }
  }

  function appendInsights(insights) {
    insights.forEach((insight) => {
      const cardElement = createInsightElement(insight);
      insightsContainer.append(cardElement);
    });
  }
  
  function createInsightElement(insight) {
    const insightClone = insightTemplate.content.cloneNode(true);
    
    const imageLink = insightClone.querySelector('.insight-card__img-link');
    const title = insightClone.querySelector('.insight-card__title');
    const excerpt = insightClone.querySelector('.insight-card__excerpt');
    const link = insightClone.querySelector('.insight-card__link');

    imageLink.style.backgroundImage = `url('${insight.thumbnail}')`;
    imageLink.setAttribute('title', insight.title);
    imageLink.href = insight.link;
    link.href = insight.link;

    title.innerHTML = insight.title;
    excerpt.innerHTML = insight.excerpt;

    return insightClone;
  }

  function setLoading(isLoading = true) {
    if (isLoading) {
      loadingTl.play();
    } else {
      loadingTl.reverse();
    }
  }

  function setLoadingFalse() {
    setLoading(false);
  }

  async function handlePagination() {
    state.page += 1;
    const insights = await getInsights();
    state.moreInsights = insights.remaining;
    appendInsights(insights.posts);
    insightsPaginationButton.style.display = state.moreInsights ? 'block' : 'none';
    updateURL();
    focusFirstNewInsight(insights);
  }

  function focusFirstNewInsight(insights) {
    const insightsCount = insightsContainer.children.length;
    if (insightsCount === 0) return;

    let firstNewInsight = insightsContainer.children[0];
    if (state.page > 1) {
      firstNewInsight = insightsContainer.children[insights.total - insights.count];
    }
    firstNewInsight.focus();
    if (categoriesMenuButton.getAttribute('aria-expanded') === 'false') {
      firstNewInsight.scrollIntoView();
    }
  }

  function readURL() {
    const url = new URL(window.location);

    const urlCategories = url.searchParams.get('c');
    const page = url.searchParams.get('pg');
    const searchTerm = url.searchParams.get('st');

    if (urlCategories) {
      const stringCategories = urlCategories.split(',');
      const typedCategories = stringCategories.map((value) => +value);
      const filteredCategories = typedCategories.filter((value) => !Number.isNaN(value));
      state.selectedInsightCategories = new Set(filteredCategories);
    }

    if (page) {
      const typedPage = +page;
      if (!Number.isNaN(typedPage)) {
        state.page = typedPage;
      }
    }

    if (searchTerm && searchTerm.length) {
      state.searchTerm = searchTerm;
    }
  }

  function updateURL() {
    const url = new URL(window.location);

    if (state.selectedInsightCategories.size) {
      url.searchParams.set('c', Array.from(state.selectedInsightCategories).toString());
    } else {
      url.searchParams.delete('c');
    }

    if (state.page > 1) {
      url.searchParams.set('pg', state.page);
    } else {
      url.searchParams.delete('pg');
    }

    if (state.searchTerm && state.searchTerm.length) {
      url.searchParams.set('st', state.searchTerm);
    } else {
      url.searchParams.delete('st');
    }

    window.history.pushState({}, '', url);
  }

  function initialLoadStackTrigger() {
    if (insightsContainer.childElementCount === 0) return;
    const children = Array.from(insightsContainer.children);
    children.unshift(insightsForm);

    const stackTriggerTl = gsap.timeline({
      once: true,
      scrollTrigger: {
        trigger: insightsForm,
        start: `top bottom-=300px`,
      },
    });

    for (const child of children) {
      stackTriggerTl.fromTo(child, {
        transform: 'translateY(-40px)',
        opacity: 0,
      }, {
        transform: 'translateY(0)',
        opacity: 1,
        duration: 0.5,
        ease: 'power2',
        delay: 0.4,
      }, '<');
    }
  }
})();
